export default {
  getIdioma() {
    const idioma = localStorage.getItem('idioma');
    if (idioma === null) {
      localStorage.setItem('idioma', 'pt');
      return 'pt';
    }
    return idioma;
  },
};
